import { Entry } from '../Entry'

export function Entry20221202() {
  return (
    <Entry title="02/12/2022 - v3.2.12">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13619/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
